var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWomanHairstyle5D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "type3_x5F_hairstyles:"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#654023",
    d: "M278.3,153c-19.1,15.4-33.4,38.3-35.9,62.3c-1.3-7.9-0.9-16.8,0.8-25.9c11.4-31.5,41.3-58.3,77.3-58.3 c-2.1-12-2.5-25.6-0.9-41.1c-27.4-5.5-55.7,3.2-77.1,20.2c-4.8,3.8-9.3,8.1-13.3,12.6c-28,27.9-27.4,69.3-8.6,100.4 c-3.1-19.4-3.4-49.1,14.3-66c-16.3,22.3-10.6,61.5-1.4,82.7c1.5,1.6,3.1,3.1,4.7,4.5c1.1,0,2.1,0.2,3,0.4c2.1,0.5,3.9,1.5,5.5,2.8 c3.7,3,6.2,7.6,8.5,12.1c0-1.6,0-3.2,0-4.8c0.7-28.9,10.9-70.3,45-84.2c1.6-0.6,3.2-1.2,4.9-1.7c-3.3,4.5-9.3,11.3-15,12.4 c12.4,2.7,34.4-4.1,43.7-14c-5.4-8.7-9.7-19-12.3-31.1C305.9,138.2,290.5,143.5,278.3,153z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#654023",
    d: "M432.8,100.8c-12.5,0.2-24.8,2.5-36.1,8.1C413.1,96,435.1,93.8,456.5,93c-0.7-0.7-1.4-1.4-2.1-2.1 C420.6,57,355,54.2,322.9,90.7l0,0c-0.2,48.3,25.2,101.6,75.7,117.7c-4.5-12.5-5.5-25.6-5-37.7c14.3,15.6,26,33.1,32.1,53.1 c0.8-4.3,1.3-8.7,1.5-13.1c0.4-8.4-0.3-16.9-2-25.2c-1.8-8.9-4.9-17.6-9.1-25.7c29.5,39.1,32.4,93,14.9,138.1 c-2.2,5.7-4.8,11.2-7.7,16.5c-0.4,0.8-0.9,1.6-1.3,2.4c1.7-0.8,3.4-1.6,5.1-2.4c10.4-5.4,19.4-12.8,26.9-21.5 c3.8-4.6,7.1-9.4,10-14.3c3-5.9,5.6-12.2,7.6-18.7c8.8-27.8,9.1-60.4-2-85.9c19.6,31.4,26.4,71.9,13.8,106.5 c14.7-16.8,23.2-39.2,16.5-65.3c4.7,5,8,10.7,10.3,16.7c0.2-1,0.4-2,0.5-3C516.3,177.7,491.2,108.1,432.8,100.8z M331.8,109.4 c5.8-10.8,14.1-19.7,26.7-24.8c14.8-5.5,28.3-4.2,42.9-2.8l0,0c-15.4,0.4-25,0.4-38.5,5.2C351.4,91.4,342.1,97.9,331.8,109.4z  M470.7,143.8c-13-14-27.4-23.9-45.6-30.7c19.4,3.9,34.9,13.4,48.8,28c15.5,17.5,23.6,35.8,27.6,56.9l0,0 C493.5,177.1,485.3,160.5,470.7,143.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9A6D49",
    d: "M243.1,189.4c-1.7,9.1-2,18-0.8,25.9c2.6-24,16.8-46.8,35.9-62.3c12.2-9.5,27.6-14.8,43.2-16.6 c-0.4-1.7-0.7-3.5-1-5.3C284.4,131.1,254.5,157.9,243.1,189.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9A6D49",
    d: "M401.5,81.8L401.5,81.8c-14.6-1.3-28.1-2.7-42.9,2.8c-12.7,5-21,14-26.7,24.8c10.2-11.5,19.5-18,31.1-22.4 C376.5,82.2,386.1,82.2,401.5,81.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9A6D49",
    d: "M474,141.1c-13.9-14.7-29.5-24.1-48.8-28c18.2,6.7,32.6,16.7,45.6,30.7c14.5,16.7,22.8,33.3,30.8,54.2l0,0 C497.6,176.9,489.5,158.6,474,141.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3A2310",
    d: "M234.8,157.2c-17.7,16.9-17.4,46.5-14.3,66c3.6,6,8,11.6,12.9,16.7C224.2,218.8,218.6,179.5,234.8,157.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3A2310",
    d: "M432.8,100.8c11.4-0.1,22.9,1.5,33.8,4.1c-3.1-4.3-6.5-8.3-10.2-12c-21.4,0.8-43.4,3-59.8,15.9 C408,103.3,420.3,101,432.8,100.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3A2310",
    d: "M469.4,174c11.1,25.6,10.8,58.1,2,85.9c0.3,12.5-1.7,24.8-6.2,36.3c0,0,0,0,0,0.1c7-4.6,12.4-9.4,18-15.8 C495.8,246,489,205.5,469.4,174z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3A2310",
    d: "M322.9,90.7L322.9,90.7L322.9,90.7c-1.1-0.3-2.2-0.5-3.3-0.7c-1.7,15.5-1.2,29.1,0.9,41.1 c0.3,1.8,0.7,3.6,1,5.3c2.6,12.1,7,22.4,12.3,31.1c17.7,28.9,47,40.8,65.9,44c-0.4-1-0.8-2.1-1.2-3.1 C348.1,192.3,322.7,139.1,322.9,90.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3A2310",
    d: "M430.9,298c17.5-45.1,14.6-99.1-14.9-138.1c4.3,8.1,7.3,16.8,9.1,25.7c16.6,45,6,97.3-21.4,137 c6.4-1.3,12.5-3.2,18.1-5.7c0.5-0.8,0.9-1.6,1.3-2.4C426.1,309.2,428.6,303.7,430.9,298z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWomanHairstyle5D);
export default __webpack_public_path__ + "static/media/woman_hairstyle_5d.c1e728523902e755bfb823a1677e5a21.svg";
export { ForwardRef as ReactComponent };